import React from 'react';
import { connect } from 'react-redux';
import { get } from 'lodash/fp';
import { publishPath, saveDraft } from 'actions/pathBuilder/index';
import ModalContainer from 'components/shared/modal/modal_container';
import { routes } from 'constants/config';
import { Button, ButtonGroup, Icon, Modal } from 'ui';
import request from 'utils/request_ajax';

const ConvertPathModal = ({
  pathId,
  closeModal,
  publish,
  saveCertificationDraft,
  isPublished,
}) => {
  const submit = () => {
    request
      .postJSON(routes.CREATE_CERTIFICATION, {
        pathId,
      })
      .then(data => {
        closeModal();
        if (isPublished) {
          publish();
        } else {
          saveCertificationDraft();
        }
        return data;
      })
      .catch(e => console.error(e));
  };

  return (
    <>
      <ModalContainer onEscape={closeModal}>
        <Modal shown className="LessonVersionModal-wrapper">
          <div className="c-brand-gray-darkest fw-b bg-gray-lightest p-24">
            {t(
              'paths.path_builder.content_type.convert_to_certification.confirmation',
            )}
          </div>
          <div className="d-f fd-c">
            <div className="fw-b pl-24 py-16">
              {t(
                'paths.path_builder.content_type.convert_to_certification.guidelines.header',
              )}
            </div>
            <div className="pl-24">
              <ul className="pl-24">
                <li>
                  {t(
                    'paths.path_builder.content_type.convert_to_certification.guidelines.applied_badge',
                  )}
                </li>
                <li>
                  {t(
                    'paths.path_builder.content_type.convert_to_certification.guidelines.receive_badge',
                  )}
                </li>
              </ul>
            </div>
            <div className="pl-24 c-danger-red">
              <Icon name="exclamation" className="mr-4" />
              <span>
                {t(
                  'paths.path_builder.content_type.convert_to_certification.warning',
                )}
              </span>
            </div>
          </div>
          <ButtonGroup alignEnd className="pb-16 pr-32 pt-8">
            <Button onClick={closeModal}>{t('common.close')}</Button>
            <button
              type="button"
              className="NewButton NewButton--blue fz-16"
              onClick={submit}
            >
              {t(
                'paths.path_builder.content_type.convert_to_certification.yes_convert',
              )}
            </button>
          </ButtonGroup>
        </Modal>
      </ModalContainer>
    </>
  );
};

const mapStateToProps = ({ pathBuilder, ...state }) => ({
  isPublished: !!get('publishedAt.date')(pathBuilder),
});

const mapDispatchToProps = {
  publish: publishPath,
  saveCertificationDraft: saveDraft,
};

export default connect(mapStateToProps, mapDispatchToProps)(ConvertPathModal);
